import * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

const LOAD_FOR_CURRENT_ENTITY_CANCELLATION_REASON = {
  noContext: 'No scenario context available',
  noEntity: 'No current cluster available',
} as const

/**
 * Relays a request for the current cluster to a self-contained functional-usage
 * request with cluster and scenario context.
 */
export const loadForCurrentEntity = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    feature.actions.loadForCurrentEntity.relay(forwardTo =>
      rxjs
        .combineLatest([
          plugin.collection.plugins.currentEntityPlugin.feature.selectors.getId()
            .asObservable,
          plugin.collection.feature.selectors.context.asObservable,
        ])
        .pipe(
          rxjs.take(1),
          rxjs.map(([clusterId, context]) => {
            if (!ents.extra.space.Cluster.Id.isId(clusterId)) {
              return {
                cancellation: {
                  reason: LOAD_FOR_CURRENT_ENTITY_CANCELLATION_REASON.noEntity,
                },
              }
            }

            if (!ents.core.admin.Context.ForScenario.isForScenario(context)) {
              return {
                cancellation: {
                  reason: LOAD_FOR_CURRENT_ENTITY_CANCELLATION_REASON.noContext,
                },
              }
            }

            return forwardTo(feature.actions.load, {
              input: { clusterId, context },
              output: () => undefined,
            })
          }),
        ),
    ).asObservable,
)
